import { Component, Mixins, Prop } from 'vue-property-decorator'
import { DateMixin, NumberMixin } from '@kwixeo/interface-vue'
import LotSelect from '../LotSelect/LotSelect.vue'

@Component({
  components: {
    LotSelect
  }
})
export default class LotSelected extends Mixins(DateMixin, NumberMixin) {
  @Prop({ required: true }) value!: KwixeoCatalog.FormStockManualMovementContent|KwixeoSales.DocumentContent
  @Prop({ required: true }) product!: KwixeoCatalog.Product
  @Prop({ default: () => [] }) usedLots!: KwixeoCatalog.UsedLots
  @Prop({ default: null }) quantity!: number|null
  @Prop({ default: null }) location!: KwixeoCatalog.StockLocation|null
  @Prop({ default: 0 }) autoSelect!: number
  @Prop({ default: () => (() => true) }) lotsFilter!: (lot: KwixeoCatalog.UsedLot) => boolean


  get computedQuantity (): number {
    let quantity = this.quantity ?? this.value.quantity
    if (quantity < 0) {
      quantity = 0
    }
    return quantity
  }

  get filteredUsedLots (): KwixeoCatalog.UsedLots {
    return (this.value.used_lots ?? []).filter(this.lotsFilter)
  }
}
